import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';
import { AutoQaResponse } from '../../team-apis/otterdam/auto-qa-response';
import { AutoQaScriptToValidate } from '../../team-apis/otterdam/auto-qa-script-to-validate';
import { Task } from '../../team-apis/otterdam/task';

@Injectable({ providedIn: 'root' })
export class AutoQaResourceService extends UrlRequestService {
  async validate({
    task,
    userId,
    scripts,
    token,
    projectId,
  }: {
    task: Partial<Task>;
    userId: number;
    scripts: AutoQaScriptToValidate[];
    token: string;
    projectId: number;
  }) {
    return super.request<AutoQaResponse>(
      'POST',
      `${environment.autoQaServiceBaseUrl}/api/v1/validations`,
      {
        headers: { Authorization: 'Bearer ' + token },
        body: {
          task,
          scripts,
          user_id: userId,
          project: { id: projectId },
        },
      },
    );
  }
}
